import React, { useCallback, useState, useEffect } from "react";
import Dropzone from "react-dropzone";
import styles from "../onboard.module.css";
import pdfImage from "../../../public/assets/pdfImage.svg";
import editIcon from "../../../public/assets/EditIcon.svg";
import { onOpenDocument } from "../../../utils";

const FileUploader = ({
  onDrop,
  acceptedFormats,
  maxSize,
  name,
  label,
  sublabel = "",
  loading,
  onRemoveButton,
  showRemove = true,
  preUploadedFile = null,
}) => {
  const [files, setFiles] = useState([]);
  const [fileSize, setFileSize] = useState(0);

  const handleDrop = useCallback(
    (acceptedFiles) => {
      const validFiles = acceptedFiles.filter(
        (file) =>
          acceptedFormats.includes(file.type) ||
          acceptedFormats.includes(`.${file.name.split(".").pop()}`)
      );

      setFiles(validFiles);
      onDrop(validFiles, name || label);
    },
    [onDrop, acceptedFormats]
  );

  useEffect(() => {
    if (files && files.length) {
      setFileSize(files[0].size);
    }
  }, [files]);

  useEffect(() => {
    if (preUploadedFile) {
      const existingFile = {
        name: label,
        preview: preUploadedFile,
        type: preUploadedFile.endsWith(".pdf")
          ? "application/pdf"
          : "image/png",
      };
      setFiles([existingFile]);
    }
  }, [preUploadedFile]);

  const onRemove = (e) => {
    if (!loading) {
      e.stopPropagation();
      setFiles([]);
      if (onRemoveButton) {
        onRemoveButton(name || label);
      } else {
      }
    }
  };

  const onPreview = (file) => {
    let filePreview;

    if (file instanceof Blob || file instanceof File) {
      filePreview = URL.createObjectURL(file);
    } else if (file.preview) {
      filePreview = file.preview;
    } else if (file.path) {
      filePreview = file.path;
    } else {
      return;
    }

    const pdf = file?.preview?.includes(".pdf") || file?.type?.includes("pdf");

    onOpenDocument(filePreview, pdf);
  };

  return (
    <div style={{ cursor: "pointer" }}>
      <Dropzone
        onDrop={handleDrop}
        accept={acceptedFormats}
        maxSize={maxSize}
        multiple={false}
        disabled={loading}
      >
        {({ getRootProps, getInputProps }) => (
          <>
            {files.length === 0 ? (
              <div
                {...getRootProps()}
                className={`dropzone ${styles.passportUploadCol}`}
              >
                <input {...getInputProps()} />
                <p
                  style={{
                    fontSize: "12px",
                    marginBottom: "0px",
                    lineHeight: "15px",
                  }}
                >
                  {label || name}
                </p>
                {sublabel !== "" && (
                  <p className={styles.fileSublabel}>{sublabel}</p>
                )}
              </div>
            ) : (
              <div {...getRootProps({ className: "dropzone" })}>
                <input {...getInputProps()} />
                <div className={styles.uploadBox}>
                  {fileSize > 5000000 ? (
                    <div className={styles.fileSize}>
                      <div style={{ marginBottom: "16px" }}>
                        File should be under 5MB
                      </div>
                      <div className={styles.uploadTitle} onClick={onRemove}>
                        Re-upload
                      </div>
                    </div>
                  ) : (
                    <div className={styles.title}>
                      <div
                        style={{
                          height: "200px",
                          marginTop: "0px",
                          width: "200px",
                        }}
                      >
                        {files.map((file) => (
                          <div
                            key={file.name}
                            className={styles.uploadedImageDiv}
                            onClick={() => onPreview(file)}
                          >
                            {file.preview?.includes(".pdf") ||
                            file.type?.includes("pdf") ? (
                              <div className={styles.uploadedImageDiv}>
                                <img
                                  src={pdfImage}
                                  alt="PDF Preview"
                                  className={styles.uploadedImage}
                                />
                              </div>
                            ) : (
                              <div className={styles.uploadedImageDiv}>
                                <img
                                  src={
                                    file instanceof Blob || file instanceof File
                                      ? URL.createObjectURL(file)
                                      : file.preview
                                  }
                                  className={styles.uploadedImage}
                                  alt="Uploaded Preview"
                                />
                              </div>
                            )}
                          </div>
                        ))}

                        {showRemove === true && (
                          <button
                            className={styles.removeButton}
                            onClick={onRemove}
                          >
                            ✕
                          </button>
                        )}
                        <div
                          className={styles.labelDiv}
                          style={{ display: "flex", flexDirection: "row" }}
                        >
                          <p
                            className={styles.label}
                            onClick={() => onPreview(files[0])}
                          >
                            {label}
                          </p>
                          <p
                            style={{
                              width: "30%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginBottom: "0px",
                            }}
                          >
                            <img
                              src={editIcon}
                              style={{ height: "100%", width: "20px" }}
                              alt="edit"
                            />
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </Dropzone>
    </div>
  );
};

export default FileUploader;
